// @flow
import connectWebActions from 'fg-frontend/src/webComponents/connectWebActions';
import { connectWebComponents } from 'fg-frontend/src/webComponents/decorate';
// import autoTitleLinksWithBlankTarget from 'fg-frontend/src/components/autoTitleLinksWithBlankTarget';
// import safeBlankLinks                from 'fg-frontend/src/components/safeBlankLinks';
import cookiesPolicy from './components/CookiesPolicy/index';
// import phoneLink                     from 'fg-frontend/components/PhoneLink';

import configureWebComponents from './configureWebComponents';
import configureWebActions from './configureWebActions';

// import 'fg-frontend/ramjet/liveValidation';
// import('./components/plUpload/fg.upload');                // PL upload
// import 'bootstrap/js/dist/collapse';

cookiesPolicy({
  enableImg: false,
  enableTechnicalButton: true,
  messages: {
    cs: {
      perex: 'Chceme, aby&nbsp;pro&nbsp;vás&nbsp;bylo procházení webu co&nbsp;nejpříjemnější. Proto používáme soubory cookies, které ho&nbsp;pomáhají neustále rozvíjet a&nbsp;zlepšovat. Navíc nám&nbsp;a&nbsp;našim partnerům umožňují zobrazovat relevantní obsah jen&nbsp;pro&nbsp;vás. Ke&nbsp;zpracování některých cookies potřebujeme váš&nbsp;souhlas, který nám&nbsp;dáte kliknutím na&nbsp;„Povolit všechny cookies“. Nastavení si&nbsp;můžete kdykoliv upravit. Poskytnuté informace jsou v&nbsp;bezpečí a&nbsp;nedostane se&nbsp;k&nbsp;nim, kdo&nbsp;nemá. Více najdete na&nbsp;stránce <a class="cookies-policy__link" href="/cs/informace-o-webu">Informace o&nbsp;webu</a>.',
    },
    en: {
      perex: 'We want your browsing experience to be as pleasant as possible. That\'s why we use cookies to help us continuously develop and improve our website. In addition, they allow us and our partners to display relevant content only for you. We need your consent to process some cookies, which you can give us by clicking "Allow all cookies". You can adjust your settings at any time. The information you provide is safe and will not be accessed by anyone who doesn\'t have it. You can find more information on the <a class="cookies-policy__link" href="/en/informace-o-webu">Website information</a>.',
    },
    de: {
      perex: 'Wir möchten, dass Ihr Surferlebnis so angenehm wie möglich ist. Deshalb verwenden wir Cookies, um unsere Website kontinuierlich weiterzuentwickeln und zu verbessern. Darüber hinaus ermöglichen sie uns und unseren Partnern, nur für Sie relevante Inhalte anzuzeigen. Für die Verarbeitung einiger Cookies benötigen wir Ihre Zustimmung. Diese können Sie uns durch Klicken auf "Alle Cookies zulassen" erteilen. Sie können Ihre Einstellungen jederzeit anpassen. Die von Ihnen angegebenen Informationen sind sicher und werden nicht von Personen abgerufen, die diese nicht haben. Weitere Informationen finden Sie auf der Seite <a class="cookies-policy__link" href="/de/informace-o-webu">Informationen über die Website</a>.',
    },
    sl: {
      heading: 'Nastavitve piškotkov: Da bi spletno mesto delovalo, kot bi moralo',
      perex: 'Želimo, da bi bila vaša izkušnja brskanja čim bolj prijetna. Zato uporabljamo piškotke, ki nam pomagajo nenehno razvijati in izboljševati našo spletno stran. Poleg tega nam in našim partnerjem omogočajo, da vam prikažemo ustrezno vsebino. Za obdelavo nekaterih piškotkov potrebujemo vaše soglasje, ki nam ga lahko daste s klikom na »Dovoli vse piškotke«. Nastavitve lahko kadar koli prilagodite. Informacije, ki jih posredujete, so varne in do njih ne bo dostopal nihče, ki jih nima. Več informacij najdete na strani <a class="cookies-policy__link" href="sl/informace-o-webu">Informace o spletu</a>.',
      closeBtn: 'Zapri',
      settingsBtn: 'Podrobne nastavitve',
      technicalBtn: 'Samo tehnični piškotki',
      acceptAllBtn: 'Dovoli vse piškotke',
    },
  },
  settingsMessages: {
    cs: {
      perex: 'Zde si můžete nastavit, jaké soubory cookies budeme zpracovávat. Více informací najdete na stránce <a class="cookies-settings__link" href="/cs/informace-o-webu">Informace o&nbsp;webu</a>.',
    },
    en: {
      perex: 'Here you can set which cookies we will process. For more information, please visit the <a class="cookies-settings__link" href="/en/informace-o-webu">Website information</a>.',
    },
    de: {
      perex: 'Hier können Sie einstellen, welche Cookies wir verarbeiten. Weitere Informationen finden Sie auf der Seite <a class="cookies-settings__link" href="/de/informace-o-webu">Informationen über die Website</a>.',
    },
    sl: {
      heading: 'Nastavitve piškotkov',
      perex: 'Tukaj lahko nastavite, katere piškotke bomo obdelovali. Za več informacij obiščite stran <a class="cookies-settings__link" href="sl/informace-o-webu">Informace o spletu</a>.',
      acceptAllBtn: 'Dovoli vse piškotke',
      acceptSelectedBtn: 'Dovoli izbrane piškotke',
      checkboxStateOff: 'Izklopljeno',
      checkboxStateOn: 'Vklopljeno',
      closeBtn: 'Zapri',
      technicalTitle: 'Tehnični piškotki',
      technicalPerex: 'Nujni so za prikaz našega spletnega mesta in njegovo pravilno delovanje. Ti piškotki so obvezni in jih ni mogoče izklopiti.',
      technicalState: 'Vedno vklopljeno',
      analyticsMarketingTitle: 'Analitični in trženjski piškotki',
      analyticsTitle: 'Analitični piškotki',
      analyticsPerex: 'Pomagajo analizirati delovanje našega spletnega mesta glede na vedenje obiskovalcev in ga po potrebi ustrezno prilagoditi in spremeniti.',
      marketingTitle: 'Trženjski piškotki',
      marketingPerex: 'Ti piškotki nam ali tretjim osebam omogočajo, da prilagodimo našo ponudbo storitev vašemu obisku. Ta ponudba vam je nato lahko prikazana zunaj našega spletnega mesta.',
    },
  },

});
connectWebComponents(configureWebComponents);
connectWebActions(configureWebActions, ['keyup']);
// autoTitleLinksWithBlankTarget();
// phoneLink();

// Nastaveni atributu 'noopener' vsem target="_blank" odkazum, ktere ho nemaji
// safeBlankLinks();



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWeb.js